import { render, staticRenderFns } from "./Lottie.vue?vue&type=template&id=b1b0cc3c&"
import script from "./Lottie.vue?vue&type=script&lang=js&"
export * from "./Lottie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports